export default function copyToClipboard(text: string | string[]) {
    const textarea = document.createElement("textarea");
    const lines = Array.isArray(text) ? text : [text];

    textarea.value = lines.join("\n");
    textarea.setAttribute("readonly", "");

    textarea.style = "{ display:'none' }";

    document.body.appendChild(textarea);
    textarea.select();

    // eslint-disable-next-line @typescript-eslint/no-deprecated
    document.execCommand("copy");
    document.body.removeChild(textarea);
}
